import { gql } from '@apollo/client'
import { PICTURES_LIST } from './picture'
import { ROLE } from './role'
import { USER_GROUP } from './userGroup'

export const ORGANIZATION_TRIAL = gql`
  fragment OrganizationTrial on OrganizationTrial {
    type
    status
    endsAt
    previousEndsAt
    convertedAt
    maxAudits
    isGenAISelfServeLocked
    hasDeliveredAudit
    launchedAuditsCount
  }
`

export const ORGANIZATION_AI_WATERMARK = gql`
  fragment OrganizationAiWatermark on OrganizationAiWatermark {
    isEnabled
    logo {
      ...PicturesList
    }
    opacityPercent
    sizePercent
    marginPercent
    position
  }
  ${PICTURES_LIST}
`

export const ORGANIZATION_PREFERENCES = gql`
  fragment OrganizationPreferences on OrganizationPreferences {
    instantLayer
    genericStageTemplates
    plainRenderingMode
    scenesAsJPEG
    visualLayersDownload
    exportPSD
    exportEXR
    exportTIF
    seeMarketplaceSection
    pivotPointTypesAdministration
    createPDPPackageAutomatically
    moveAndScale
    bypassPDPCustomerReview
    skuListTemplateUrl
    deliverVisualsViaPDPPackage
    hasNfiniteProductsListing
    hasNewSceneOffers
    hasFreestylePackshotOffers
    hasFreestyle360Offers
    hasOneClickOffers
    hasGenAISelfServeOffers
    hideAuditAutomatically
    showBenchmarkDataOnAudits
  }
`

export const ORGANIZATION = gql`
  fragment Organization on Organization {
    id
    name
    forInternalTesting
    origin
    picture {
      ...PicturesList
    }
    users {
      role {
        roleType
      }
      status
    }
    organizationPreferences {
      ...OrganizationPreferences
    }
    isVCPEndpoint
    domain
    packageRequirementsCount
  }
  ${PICTURES_LIST}
  ${ORGANIZATION_PREFERENCES}
`

export const ORGANIZATION_EDIT = gql`
  fragment OrganizationEdit on Organization {
    id
    name
    code
    createdAt
    forInternalTesting
    origin
    picture {
      ...PicturesList
    }
    contracts {
      id
      contractType
      currentLabel
      status
    }
    organizationPreferences {
      ...OrganizationPreferences
    }
    isVCPEndpoint
    isCurrentCustomer
    isSuggestedRetailer
    suggestedRetailerOrigins
    trial {
      ...OrganizationTrial
    }
    aiWatermark {
      ...OrganizationAiWatermark
    }
    businessContracts {
      id
      reference
      isLive
      csmUsers {
        id
        firstName
        lastName
        email
        picture {
          ...PicturesList
        }
      }
    }
    parentOrganization {
      id
      name
      picture {
        ...PicturesList
      }
    }
    hierarchy {
      id
      name
      picture {
        ...PicturesList
      }
      parentOrganizationId
    }
  }
  ${PICTURES_LIST}
  ${ORGANIZATION_PREFERENCES}
  ${ORGANIZATION_TRIAL}
  ${ORGANIZATION_AI_WATERMARK}
`

export const ORGANIZATION_EDIT_USER = gql`
  fragment OrganizationEditUser on User {
    id
    firstName
    lastName
    email
    certificates {
      id
      certificateType
      picture {
        ...PicturesList
      }
      status
      currentLabel
    }
    role {
      ...Role
    }
    picture {
      ...PicturesList
    }
    userPreferences {
      language
    }
    serviceToken {
      token
    }
    discord
  }
  ${ROLE}
  ${PICTURES_LIST}
`

export const ORGANIZATION_USER = gql`
  fragment OrganizationUser on OrganizationUser {
    user {
      id
      firstName
      lastName
      email
      createdAt
      serviceToken {
        prefix
        token
      }
      picture {
        ...PicturesList
      }
    }
    role {
      ...Role
    }
    status
    userGroups {
      ...UserGroup
    }
  }
  ${ROLE}
  ${PICTURES_LIST}
  ${USER_GROUP}
`

export const ORGANIZATION_APPLICATION = gql`
  fragment OrganizationApplication on Organization {
    id
    name
    code
    origin
    picture {
      ...PicturesList
    }
    forInternalTesting
    organizationPreferences {
      ...OrganizationPreferences
    }
    paginatedContracts(filter: $contractFilter) {
      items {
        id
        contractType
        status
        defaultPermissions
        group
      }
    }
    packageExpectations {
      id
      expectations {
        id
      }
    }
    vcpRetailers {
      id
      name
      picture {
        ...PicturesList
      }
      domain
      origin
      pivotDataIdentifiers
      packageRequirement {
        id
        status
      }
    }
    draftProductsCount
    activeProductsCount
    packageGuidelinesCount
    trial {
      ...OrganizationTrial
    }
  }
  ${PICTURES_LIST}
  ${ORGANIZATION_PREFERENCES}
  ${ORGANIZATION_TRIAL}
`
